<template>
  <ParentPortal :tabs="sidePanelComponents">
    <router-view v-if="reference" :reference="reference" class="main-content"/>
  </ParentPortal>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { IfacAwardDetails, IfacNominationDetails, IfacReferenceDetails } from '@ifac/ui';
import referencesMixin from '@/mixins/awards/references.mixin';
import ParentPortal from '@/views/components/portals/ParentPortal.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [referencesMixin],
  name: 'ReferencesEditPortal',
  components: {
    ParentPortal,
    IfacNominationDetails,
    IfacReferenceDetails,
  },
  created() {
    const params = {
        relations: ['nomination.award'],
    };
    this.mx_fetchReference(params).then((response) => {
      this.reference = response.data.data;
    });
  },
  data() {
    return {
      reference: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    sidePanelComponents() {
      if (!this.reference) {
        return [];
      }

      const tabs = [
        {
          icon: ['far', 'award'],
          headerText: 'Award',
          component: IfacAwardDetails,
          options: {
            award: this.reference.nomination.award,
          },
        },
        {
          icon: ['far', 'user-check'],
          headerText: 'Nomination',
          component: IfacNominationDetails,
          options: {
            nomination: this.reference.nomination,
            hideReferees: true,
          },
        },
        {
          icon: ['far', 'envelope'],
          headerText: 'Invitation',
          component: IfacReferenceDetails,
          options: {
            reference: this.reference,
          },
        },
      ];

      return tabs;
    },
  },
};
</script>
